import { useParams } from 'react-router-dom';
import Header from '../../components/Header/Header';
import MobileHeaderSmall from '../../components/MobileHeaderSmall/MobileHeaderSmall';
import { useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';
import Footer from '../../components/Footer/Footer';
import { Config } from '../../config/config';
import './oneParticipant.scss';
import AvatarImg from '../../assets/avatar-img.png';
import { getOneLecturer } from '../../services/LecturerService';

function OneParticipant() {
  const { id } = useParams();
  const [oneParticipant, setOneParticipant] = useState<any>(undefined);

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  useEffect(() => {
    getOneLecturer(id as string).then((res: AxiosResponse) => {
      console.log('res', res.data.result);
      setOneParticipant(res.data.result);
    });
  }, []);

  return (
    <div className="one-participant">
      <Header main={false} />
      <MobileHeaderSmall main={false} />
      <div className="body-lec">
        <h1>Učesnik</h1>
        <div className="header-lec">
          {oneParticipant?.photo?.id ? (
            <img
              className="image"
              src={`${Config.apiRoot}/files/storage/${oneParticipant?.photo?.id}`}
            />
          ) : (
            <img className="image" src={AvatarImg} />
          )}

          <h2 style={{ color: '#C7363D' }}>
            {oneParticipant?.firstName} {oneParticipant?.lastName}
          </h2>
        </div>
        <div className="bio">{oneParticipant?.biography}</div>
      </div>
      <Footer />
    </div>
  );
}

export default OneParticipant;
